import Head from "./Head";
import List from "./List";
import Calendar from "./Calendar";

export default {
    Head,
    List,
    Calendar
}